import { render, staticRenderFns } from "./filter_channel.vue?vue&type=template&id=3e4479c3&scoped=true"
import script from "./filter_channel.vue?vue&type=script&lang=js"
export * from "./filter_channel.vue?vue&type=script&lang=js"
import style0 from "./filter_channel.vue?vue&type=style&index=0&id=3e4479c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4479c3",
  null
  
)

export default component.exports